import React, { useEffect } from 'react';
import { graphql, useFragment } from 'react-relay';
import type { Nav4DragAndDropMenuItemProps } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import type { OperationsMenuForLanding$key } from './__generated__/OperationsMenuForLanding.graphql';
import { AlertsMenuItemContent } from './alerts-content/alerts-menu-item/AlertsMenuItemContent.tsx';
import { OperationsExpandableMenuItem } from './operations-expandable-menu-item/index.tsx';
import { AlertsMenuItemContentNew } from './alerts-content/alerts-menu-item/AlertsMenuItemContentNew.tsx';
import { useAlertsPopoutStore } from './operations-expandable-menu-item/action-buttons/useAlertsPopoutStore.tsx';

type OperationsMenuForLandingProps = Nav4DragAndDropMenuItemProps & {
	isExpanded: boolean;
	queryRef: OperationsMenuForLanding$key;
};

export const OperationsMenuForLanding = (
	props: OperationsMenuForLandingProps,
): React.JSX.Element => {
	const { isExpanded, queryRef, ...dndProps } = props;
	// eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
	const data = useFragment<OperationsMenuForLanding$key>(
		graphql`
			fragment OperationsMenuForLanding on Query {
				...AlertsMenuItemContentNew
				...AlertsMenuItemContent
			}
		`,
		// eslint-disable-next-line @atlassian/relay/use-fragment-naming
		queryRef,
	);

	const {
		state: { lastVisitedSearch },
		setContent,
	} = useAlertsPopoutStore();

	useEffect(() => {
		if (lastVisitedSearch) {
			setContent(<AlertsMenuItemContent queryRef={data} />);
		}
	}, [data, lastVisitedSearch, setContent]);

	return (
		<UFOSegment name="nav4-sidebar-operations-trigger-button">
			<OperationsExpandableMenuItem
				AlertsMenuItemContent={
					<UFOSegment name="nav4-sidebar-operations-expanded-items">
						<AlertsMenuItemContentNew queryRef={data} />
					</UFOSegment>
				}
				isExpanded={isExpanded}
				{...dndProps}
			/>
		</UFOSegment>
	);
};
